import { Button } from '../ui/Button.jsx';
import { useTranslation } from '../../i18n/useTranslation.js';
import { exportCsv } from '../../utils/csv.js';

/**
 * Exports the rows currently passed in (i.e. the loaded/filtered view) to CSV.
 *
 * @param {object} props
 * @param {Array<object>} props.rows
 * @param {Array<{key: string, label: string, map?: (row) => any}>} props.columns
 * @param {string} props.filename  - without extension
 */
export function CsvExportButton({ rows, columns, filename }) {
  const { t } = useTranslation();
  const disabled = !rows || rows.length === 0;
  return (
    <Button
      variant="default"
      onClick={() => exportCsv(filename, rows, columns)}
      disabled={disabled}
      title={t('csv.export')}
    >
      ↓ {t('csv.export')}
    </Button>
  );
}
